import { useState, useEffect } from "react";

export function useLoadingMessages(messages: string[], active: boolean, intervalMs = 2800) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!active) { setIndex(0); return; }
    if (messages.length <= 1) return;
    const id = setInterval(() => setIndex(i => (i + 1) % messages.length), intervalMs);
    return () => clearInterval(id);
  }, [active, messages.length, intervalMs]);

  return { message: messages[index], animKey: index };
}
